module.exports = __webpack_public_path__ + "img/bobis_bobocoin.gm.8e1cc90.png";